module.exports = "<button type=\"button\"\n        ng-if=\"renewalReportCtrl.loaded && renewalReportCtrl.btnType === 'btn'\"\n        class=\"btn btn-success\"\n        ng-click=\"renewalReportCtrl.generate()\">\n\tGenerate Renewal Report\n</button>\n\n<a  ng-click=\"renewalReportCtrl.generate()\"\n    ng-if=\"renewalReportCtrl.loaded && renewalReportCtrl.btnType === 'link'\"\n    class=\"li-a-p\" href=\"\">\n  Generate Renewal Report\n</a>";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/users/reports/renewals/template.html
// module id = 1651
// module chunks = 0